import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  IconButton,
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { trackExternalLink } from '../../utils/googleAnalytics';

const colors = {
  black: '#000000',
  darkRed: '#451a15',
  red: '#970000',
  yellow: '#fdb200',
  offWhite: '#f6ede7',
};

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        backgroundColor: colors.offWhite,
        color: colors.black,
        borderTop: `3px solid ${colors.red}`,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info - Left Side */}
          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: colors.darkRed }}>
                Ulpian AI
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Zelinska 5, 10000 Zagreb
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Croatia
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                VAT ID: HR64992711010
              </Typography>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mt: 2,
                mb: 2,
                justifyContent: { xs: 'center', md: 'flex-start' }
              }}>
                <IconButton
                  href="https://www.linkedin.com/company/ulpian-ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackExternalLink('LinkedIn')}
                  sx={{
                    color: colors.darkRed,
                    '&:hover': {
                      backgroundColor: 'rgba(69, 26, 21, 0.08)',
                    },
                    p: 1,
                  }}
                  aria-label="Visit Ulpian AI on LinkedIn"
                >
                  <LinkedInIcon sx={{ fontSize: 28 }} />
                </IconButton>
              </Box>
              <Typography variant="body2">
                © {currentYear} {t('footer.copyright')}
              </Typography>
            </Box>
          </Grid>

          {/* Links and Contact - Right Side */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Link
                  component={RouterLink}
                  to="/privacy-policy"
                  sx={{
                    color: colors.darkRed,
                    mb: 1,
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {t('footer.privacy_policy')}
                </Link>
                <Link
                  component={RouterLink}
                  to="/cookie-policy"
                  sx={{
                    color: colors.darkRed,
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {t('footer.cookie_policy')}
                </Link>
                <Box
                  component="img"
                  src="/HR_FundedbytheEU_RGB_POS.png"
                  alt="Funded by the European Union"
                  sx={{
                    mt: 2,
                    width: '100%',
                    maxWidth: 320,
                    height: 'auto',
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
